import React, { Suspense, lazy } from 'react';
import { HashRouter as Router, Route, Routes } from "react-router-dom";
import Footer from './components/Footer';
import Contact from './pages/Contact';
import Home from './pages/Home';
import Navigation from './components/Navigation';
import ScrollToTopButton from './components/ScrollToTopButton';
import Preloader from './components/Preloader';
// import Navbar from './components/Navbar';

const Data = lazy(() => import('./pages/Data'));
const ResearchArea = lazy(() => import('./pages/ResearchAreasList'));
const Publications = lazy(() => import('./pages/Publications'));
const GrantsAndFunds = lazy(() => import('./pages/GrantsAndFunds'));
const PeoplesPage = lazy(() => import('./pages/People/PeoplesPage'));
const PeopleDetails = lazy(() => import('./pages/People/PeopleDetails'));
const News = lazy(() => import('./pages/News'));
const Disclaimer = lazy(() => import('./pages/Disclaimer'));
const PrivacyPolicy = lazy(() => import('./pages/PrivacyPolicy'));
const Geoportals = lazy(() => import('./pages/DataPortals'));
const ResearchAreaDetails = lazy(() => import('./pages/ResearchAreaDetails'));
const JournalArticles = lazy(() => import('./pages/Publications/JournalArticles'));
const BooksChaptersReviewArticles = lazy(() => import('./pages/Publications/BooksChaptersReviewArticles'));
const InvitedPapers = lazy(() => import('./pages/Publications/InvitedPapers'));
const ConferencePresentations = lazy(() => import('./pages/Publications/ConferencePresentations'));
const InternsPage = lazy(() => import('./pages/People/InternsPage'));
const AlumniPage = lazy(() => import('./pages/People/AlumniPage'));
const CurrentMemberPage = lazy(() => import('./pages/People/CurrentMemberPage'));
const PeopleGallery = lazy(() => import('./pages/People/PeopleGallery'));


const App = () => {
    return (
        <div>
            <Router>
                <Navigation />
                {/* <Navbar/> */}
                <Suspense fallback={<Preloader />}>
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/grants-and-funds" element={<GrantsAndFunds />} />
                        <Route path="/data" element={<Data />} />
                        <Route path="/people" element={<PeoplesPage />} />
                        <Route path="/people/:Name" element={<PeopleDetails />} />
                        <Route path="/research" element={<ResearchArea />} />
                        <Route path="/research/:PageLink" element={<ResearchAreaDetails />} />

                        <Route path="/publications" element={<Publications />} />
                        <Route path="/publications/journal-articles" element={<JournalArticles />} />
                        <Route path="/publications/books-expository-and-review-articles" element={<BooksChaptersReviewArticles />} />
                        <Route path="/publications/invited-papers" element={<InvitedPapers />} />
                        <Route path="/publications/conference-presentations" element={<ConferencePresentations />} />


                        <Route path="/news" element={<News />} />
                        <Route path="/contact" element={<Contact />} />
                        <Route path="/disclaimer" element={<Disclaimer />} />
                        <Route path="/privacy-policy" element={<PrivacyPolicy />} />

                        <Route path="/data-portals" element={<Geoportals />} />
                        <Route path="/people/current" element={<CurrentMemberPage />} />
                        <Route path="/people/alumni" element={<AlumniPage />} />
                        <Route path="/people/interns" element={<InternsPage />} />
                        <Route path="/people/gallery" element={<PeopleGallery />} />
                    </Routes>
                    <ScrollToTopButton />
                </Suspense>
                <Footer />
            </Router>

        </div>
    )
}

export default App